import { v4 as uuid } from "uuid";
import {Model} from "../../base/Model";
import DB from "../../DB";
import {Collection} from "../../base/Collection";
import DateHelperClass from '@/helpers/DateHelper' 



export class PositionModel extends Model  {
    x: number = 0;
    y: number = 0;
    width:number = 180;
    initWidth:number;
    paddingTop:number;
    tickWidth:number = 0;
    height:number = 0;
    extraHeight:number = 0;
    initHeight:number;
    visible: boolean = true;
    row:number = 0;
    column:number = 0;
    group: [] = [];
    open:boolean = false;
        constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data);
            
        }
        
    }
    
    public getTotalHeight():number {
        return (this.height as number) + (this.extraHeight as number);
    }
    
    public getInnerY() {
        return this.height - 10
    }
    
    public getInnerHeight() {
        return this.height - 20;
    }
    
}